import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { TemplateThumbnail, UpdateTemplateDocument } from './update.generated';

export const useUpdateTemplate = (options: ApiOptions<typeof UpdateTemplateDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(UpdateTemplateDocument, {
    ...useNotifications(UpdateTemplateDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.templates.update_success'),
    }),

    update(cache, { data }, { variables }) {
      if (data?.updateTemplate?.template == null) return;
      cache.updateFragment(
        {
          id: cache.identify(data.updateTemplate.template),
          fragment: TemplateThumbnail,
          overwrite: true,
        },
        (data) => ({
          __typename: 'Template' as const,
          thumbnailUri: variables?.patch.thumbnailUri ?? data?.thumbnailUri,
        }),
      );
    },

    ...options,
  });
};
